import React from 'react';
import { useTheme } from '@mui/material';

interface TimelineGridProps {
    weeks: Date[];
    weekWidth: number;
    headerColumnWidth: number;
}

const TimelineGrid: React.FC<TimelineGridProps> = ({
    weeks,
    weekWidth,
    headerColumnWidth,
}) => {
    const theme = useTheme();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                position: 'absolute',
                justifyContent: 'flex-end',
                zIndex: 1,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            }}
        >
            <div style={{
                width: headerColumnWidth,
                position: 'sticky',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: theme.palette.background.paper,
                borderRight: '1px solid #e0e0e0',
            }}>
            </div>

            {weeks.map((_, index) => (
                <div key={index} style={{ width: weekWidth, borderRight: '1px solid #e0e0e0', height: '100%' }}>
                </div>
            ))}
        </div>
    );
};

export default TimelineGrid;
